import * as types from './mutations-types'

export default {
  [types.EXCHANGE_RECORD_LIST] (state, data) {
    state.exchangeRecordList = data.dataList
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/store/mutations.js